import rootService from 'core/services.root';

export default rootService({
    fetchAbsenceRateConfiguration: ['GET', '/admin/absence-rate/configuration'],
    fetchConfigurations: ['GET', '/configurations/all'],
    fetchSchedules: ['GET', '/admin/absence-rate/schedule/list'],
    postAbsenceRate: ['POST', '/admin/absence-rate/configuration/store'],
    postSchedule: ['POST', '/admin/absence-rate/configuration/schedule/assign'],
    postScheduleConfig: ['POST', '/admin/absence-rate/schedule/store'],
    postSpecialDay: ['POST', '/admin/absence-rate/configuration/special-day/store'],
    putAdminRates: ['PUT', '/admin/rates'],
    putScheduleConfig: ['PUT', '/admin/absence-rate/schedule/update/:id'],
    setRecordingFlag: ['POST', '/configurations/record/enable'],
    uploadFile: ['POST', '/vadamecum/:option', { headers: { 'content-type': 'multipart/form-data' } }],
    uploadLogoFile: ['POST', '/recipe/upload/logo', { headers: { 'content-type': 'multipart/form-data' } }]
});
